// extracted by mini-css-extract-plugin
export default {"root":"Login_root__Bj4D0","logoWrap":"Login_logoWrap__2PJrH","formWrap":"Login_formWrap__JuqRo","form":"Login_form__w3G+2","footer":"Login_footer__mSmLa"};